import React from 'react';
import { CgRadioCheck, CgRadioChecked } from 'react-icons/cg';
import styles from './CheckBox.module.scss';

interface Props {
  isChecked: boolean,
  toggle?: () => void,
}

const CheckBox = ({
  isChecked,
  toggle = () => null,
}: Props) => (
  <div
    className={styles.checkboxContainer}
    onClick={toggle}
    aria-hidden
  >
    {isChecked ? <CgRadioChecked /> : <CgRadioCheck />}
  </div>
);

export default CheckBox;
